import React from "react";
import {
  Grid,
  Typography,
  Paper,
  Box,
  Container,
  useTheme,
} from "@mui/material";
import img from "../../../assets/images/list.png";
import InfoSection from "../../shared/InfoSection";
import CustomButton from "../../shared/CustomButton";
import { useTranslation } from "react-i18next";
import useNavigation from "../../../hooks/useNavigation";
const ServicesSection = ({ data = [] }) => {
  const theme = useTheme();
  const { i18n, t } = useTranslation();
  const currentLang = i18n.language;
  const { navigateTo } = useNavigation();
  const locale = i18n.language || localStorage.getItem("language") || "en";

  const handleServcies = () => {
    navigateTo(`/${locale}/services`);
  };
  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 6, textAlign: "center", overflow: "hidden" }}>
        <Box sx={{ width: { xs: "100%", md: "60%" }, margin: "0px auto" }}>
          <InfoSection
            icon={img}
            title={t("buttons.Our Services")}
            description={t(
              "missed.Comprehensive Solutions for Zakat and Tax Compliance"
            )}
            textAlign="center"
          />
        </Box>

        <Grid container spacing={4} justifyContent="center" mt="20px">
          {data.map((service, index) => (
            <Grid item xs={12} sm={6} md={6} key={index}>
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  borderRadius: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: "133px",
                  border: "1px solid #D6D8DB",
                  maxWidth: "544px",
                  mb: { xs: 0.5, sm: 2 },
                }}
              >
                <Typography
                  sx={{
                    fontSize: "20px",
                    fontWeight: "500",
                    color: theme.palette.primary.body,
                    lineHeight: "30px",
                    maxWidth: "300px",
                    margin: "0px auto",
                  }}
                >
                  {service.title[currentLang]}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mt: "64px",
          }}
        >
          <CustomButton
            backgroundImage="linear-gradient(90deg, #0A1F52 0%, #1646B8 100%)"
            onClick={handleServcies}
          >
            {t("buttons.Explore Our Full Services")}
          </CustomButton>
        </Box>
      </Box>
    </Container>
  );
};

export default ServicesSection;
